export default class LoggingEventsService {
    constructor(http) {
        this.http = http;
    }
  
    getData() {
        return new Promise((resolve, reject) => {
            this.http.get(this.backendUrl + '/notifications/loggingEvents').then(
                (response) => {
                    if (response.status === 200 && response.data) {
                        let loggingEvents = Object.values(response.data).sort(this.sortByFirstOccurence);
                        resolve(loggingEvents);
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    removeLoggingEventById(loggingEventId) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.backendUrl + '/notifications/loggingEvents/' + loggingEventId).then(
                (response) => {
                    if (response.status === 204) {
                        resolve(loggingEventId);
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    removeLoggingEvents(loggingEvents) {
        let loggingEventsIds = loggingEvents.map(loggingEvent => loggingEvent.Id);
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/loggingEvents/remove', loggingEventsIds).then(
                (response) => {
                    if (response.status === 204) {
                        resolve();
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    sortByFirstOccurence(a, b) {
        let valueA = a.FirstOccurenceTime;
        let valueB = b.FirstOccurenceTime; 
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/service/loggingEvents.js